import PortalIdParser from 'PortalIdParser';
export function fetchAllPropertyValues(objectId, objectTypeId, httpClient) {
  return httpClient.get(`inbounddb-objects/v1/crm-objects/${encodeURIComponent(objectTypeId)}/${encodeURIComponent(objectId)}?includeAllValues=true`, {
    query: {
      portalId: PortalIdParser.get()
    }
  });
}